<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mr-1" color="primary" @click.prevent="showCreatePanel()" outlined>
                <v-icon class="pr-2">fa-plus</v-icon>Add Account Manager
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-title>
              <div class="flex-grow-1"></div>
            </v-card-title>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table :headers="headers" :options.sync="options" :server-items-length="serverItemsLength"
            v-show="!loading" :items="users">
            <template v-slot:item.permission="{ item }">
                {{ item.permission ? 'Yes' : 'No' }}
              </template>
              <template v-slot:item.id="{ item }">
                <v-tooltip bottom class="mr-5" v-if="!item.is_mail_sent && !item.archived">
                <template v-slot:activator="{ on }">
                <v-btn
                      v-on="on"
                      color="primary"
                      class="mr-1"
                      outlined
                      small
                      @click.prevent="sendWelcomeEmail(item.id)"
                      :loading="loadingMailSent"
                    >
                      <v-icon small>fa-paper-plane</v-icon>
                    </v-btn>
                  </template>
                  <span>Send Welcome Email</span>
                </v-tooltip>
                <v-tooltip bottom class="mr-5" v-if="!item.archived">
                  <template v-slot:activator="{ on }">
                    <v-btn :id="item.id" v-on="on" outlined small color="secondary"
                      @click.prevent="archiveManager(item.id, 1)" class="mr-2" :loading="loadingArchive">
                      <v-img class="archiveBtnImg" src="static/archive-icon.svg"></v-img>
                    </v-btn>
                  </template>
                  <span>Archive User</span>
                </v-tooltip>
                <v-tooltip bottom class="mr-5" v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn :id="item.id" v-on="on" outlined small color="secondary"
                      @click.prevent="archiveManager(item.id, 0)" class="mr-2" :loading="loadingArchive">
                      <v-img class="archiveBtnImg" src="static/unarchive-icon.svg"></v-img>
                    </v-btn>
                  </template>
                  <span>UnArchive User</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn :id="item.id" v-on="on" outlined small color="secondary"
                      @click.prevent="showEditPanel(item.id)" :disabled="item.archived ? true : false">
                      <v-icon small>fa-pencil-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit User</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import partnerAPI from '@/api/partner.js';
import LayoutBasic from '@/layouts/PartnerHub';
import EditUser from '@/components/partner/account-manager/Edit';
import CreateUser from '@/components/partner/account-manager/Create';
import userAPI from "@/api/user.js";

export default {
  name: 'AccountManager',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        {
          text: 'First Name',
          value: 'first_name',
          sortable: false,
        },
        {
          text: 'Last Name',
          value: 'last_name',
          sortable: false,
        },
        {
          text: 'Email',
          value: 'email',
          sortable: false,
        },
        {
          text: 'Can Create Customers',
          value: 'permission',
          sortable: false
        },
        {
          text: '',
          value: 'id',
          sortable: false,
          align: 'end',
        },
      ],
      email: '',
      password: '',
      id: '',
      fullName: '',
      users: [],
      userdata: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      confirmDelete: 'Are you sure you wish to delete this manager?',
      loadingArchive:false,
      errorMessage: "Oops something went wrong",
      loadingMailSent: false,
      mailSentSuccessMessage: "Mail has been successfully sent."
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    this.setEventBus();
  },
  watch: {
    options: {
      handler() {
        this.getManagers();
      },
      deep: true,
    },
  },
  methods: {
    getManagers() {
      this.loading = true;
      partnerAPI
        .getManagers(
          this.params,
          this.searchParams,
          this.$store.getters.user.id + '&include=company&manager=yes'
        )
        .then((resp) => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    resetSearch() {
      this.searchParams = '';
      this.getManagers();
    },
    setEventBus() {
      EventBus.$on('USERS_UPDATED', (payload) => {
        this.params = payload;
        this.getManagers();
      });
    },
    applySearch() {
      this.searchParams =
        this.params +
        '&search=first_name:' +
        this.search +
        ';last_name:' +
        this.search +
        ';company_name:' +
        this.search;
      this.getManagers();
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditUser,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateUser,
        props: {
          params: this.params,
          id: this.$store.getters.user.id,
        },
        openOn: 'right',
      });
    },
    deleteManager(id) {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processDeleteManager(toast, id),
          }          
        ],
      });
    },
    processDeleteManager(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      partnerAPI.deleteManager(id).then(() => {
        this.getManagers();
        this.loading = false;
      });
    },
    archiveManager(id,archived){
      let confirmArchive = 'Are you sure you wish to archive this user?';
      
      if(!archived)
       confirmArchive = 'Are you sure you wish to unarchive this user?';

      this.$snotify.confirm(confirmArchive, {
        backdrop: 0.3, buttons: [
          { text: 'Cancel',className: 'toast-cancel-button', },
          {
            text: 'Continue',className: 'toast-continue-button',
            action: (toast) => this.processArchiveUser(toast, id, archived),
          }         
        ],
      });
    },
    processArchiveUser(toast, id,archived){
      this.$snotify.remove(toast.id);
      this.loading = true;
      this.loadingArchive = true;
      userAPI.archiveManager(id,archived).then(() => {
        this.getManagers();
        this.loading = false;
        this.loadingArchive = false;
      }).catch(() => {
        this.$snotify.error(this.errorMessage);   
        this.loading = false;
        this.loadingArchive = false;
      });
    },
    sendWelcomeEmail(id) {
      this.loadingMailSent = true;
      userAPI.sendWelcomeEmail(id).then(() => {
        this.loadingMailSent = false;
        this.getManagers();
        this.$snotify.success(this.mailSentSuccessMessage);  
        setTimeout(() => {
              this.$gf.removeBackdrop();
            },300);
      }).catch(() => {
        this.loadingMailSent = false;
        this.$snotify.error(this.errorMessage);   
        setTimeout(() => {
              this.$gf.removeBackdrop();
            },300);
      });
    },
  },
};
</script>
<style scoped>
.archiveBtnImg{
  width: 25px;
}
</style>